import 'deepmerge';
import { parsePhoneNumber } from 'libphonenumber-js';

function isHexColorCode(code) {
    return /^#([A-Fa-f0-9]{3}){1,2}$/.test(code);
}

var ARMobileInput = {
render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:[
    'ar-mobile-input',
    _vm.multipleLines && 'multiple-lines' ],attrs:{"ar-widget-id":"ar-mobile-input","ar-widget-meta":_vm.arWidgetMeta || _vm.computedArWidgetMeta,"name":"ar-mobile-input"}},[_c('ar-country-select',{staticClass:"country-select",style:({
      position: 'relative',
      width: _vm.multipleLines ? '100%' : '151px',
      borderTopRightRadius: !_vm.multipleLines ? '0' : null,
      borderBottomRightRadius: !_vm.multipleLines ? '0' : null,
      zIndex: _vm.$arStyle.zIndex.high,
    }),attrs:{"value":_vm.possibleCountryISO || _vm.countryCallingCode,"value-type":_vm.possibleCountryISO ? 'iso' : 'code',"top-selections-by-iso":_vm.topSelectionsByIso,"color":_vm.color,"has-error":_vm.hasError,"enable-clear":_vm.enableClear,"dropdown-width":_vm.multipleLines ? null : 300,"size":_vm.multipleLines ? 'md' : 'xs',"input-font-size":_vm.inputFontSize},on:{"input":_vm.handleCountryCallingCodeChange,"select":_vm.handleCountrySelect,"clear":_vm.handleCountryClear}}),_vm._v(" "),_c('ar-input',{staticClass:"mobile-input",style:({
      width: _vm.multipleLines ? '100%' : 'calc(100% - 149px)',
      borderTopLeftRadius: !_vm.multipleLines ? '0' : null,
      borderBottomLeftRadius: !_vm.multipleLines ? '0' : null,
      borderLeft: _vm.inputZIndex === '1' && !_vm.multipleLines ? 'none' : null,
      zIndex: _vm.inputZIndex,
    }),attrs:{"value":_vm.nationalNumber,"has-error":_vm.hasError,"placeholder":"Mobile number","input-font-size":_vm.inputFontSize,"autocomplete":"tel-national"},on:{"focus":function($event){_vm.inputZIndex = '3';},"blur":function($event){_vm.inputZIndex = '1';},"input":_vm.handleNationalNumberInput}})],1)},
staticRenderFns: [],
  name: 'MobileInput',

  props: {
    arWidgetMeta: String,
    value: {
      type: String,
      default: null,
    },
    color: {
      type: String,
      default: 'purple',
      validator: (value) => {
        return ['purple'].indexOf(value) > -1 || isHexColorCode(value);
      },
    },
    enableClear: {
      type: Boolean,
      default: false,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    multipleLines: {
      type: Boolean,
      default: false,
    },
    inputFontSize: {
      type: String,
      default: 'xs',
      validator: (val) => ['xxs', 'xs', 'sm', 'md', 'lg'].indexOf(val) > -1,
    },
    topSelectionsByIso: {
      type: Array,
      default: null,
    }
  },

  data() {
    return {
      countryCallingCode: '',
      possibleCountryISO: '',
      nationalNumber: '',
      inputZIndex: '1',
    };
  },

  computed: {
    computedArWidgetMeta() {
      return [
        `value=${this.countryCallingCode}${this.nationalNumber};`,
        `code=${this.countryCallingCode};`,
        `number=${this.nationalNumber};`,
      ].join('');
    },
    scratchMobileNumber() {
      return `${this.countryCallingCode}${this.nationalNumber}`;
    },
  },

  watch: {
    value: {
      handler(newValue) {
        // Don't update code and number if newValue equals to code and number combined
        if (newValue === this.scratchMobileNumber) {
          return;
        }
        this.updateCodeAndNumber();
      },
      immediate: true,
    },
  },

  methods: {
    updateCodeAndNumber() {
      if (!this.value) {
        return;
      }
      try {
        const phoneNumber = parsePhoneNumber(this.value);
        this.countryCallingCode = `+${phoneNumber.countryCallingCode}`;
        this.nationalNumber = phoneNumber.nationalNumber;

        // For case if country code not unique we try to guess
        this.possibleCountryISO = phoneNumber.country ? phoneNumber.country.toLowerCase() : '';
      } catch (error) {
        // If there's an error but we still have a value saved, then use that value as the nationalNumber, but keep countryCallingCode null
        if (this.value && parseInt(this.value) > 0) {
          this.countryCallingCode = '';
          this.nationalNumber = this.value;
        } else {
          // If the mobile number is invalid, make the value null
          console.warn('From ar-mobile-input', error);
          this.emitInputEvent(null);
        }
      }
    },

    /**
     * 1. If mobile number is valid, we have to make sure it's 100% valid,
     *    instead of having a "0" after country calling code and saying it's valid.
     * 2. If mobile number is invalid, just emit input with incorrect value,
     *    coz we have to let parents know users' putting a wrong number.
     */
    emitInputEvent(mobileNumber) {
      if (!/^\+?[\s\d-]+$/.test(mobileNumber)) {
        // Just emit wrong value if non-characters found in mobile number
        this.$emit('input', mobileNumber);
        return;
      }
      try {
        // This will help us validate mobile number per rule of country
        const phoneNumber = parsePhoneNumber(mobileNumber);
        if (phoneNumber.isValid()) {
          if (phoneNumber.number !== this.scratchMobileNumber) {
            /**
             * Auto correct input values, so the input will also changes,
             * and users can notice it.
             */
            this.countryCallingCode = `+${phoneNumber.countryCallingCode}`;
            this.nationalNumber = phoneNumber.nationalNumber;
          }
          this.$emit('input', phoneNumber.number);
        } else {
          this.$emit('input', mobileNumber);
        }
      } catch (error) {
        this.$emit('input', mobileNumber);
      }
    },

    updateCountryCallingCode(countryCallingCode) {
      this.countryCallingCode = countryCallingCode;

      this.$nextTick(() => {
        this.emitInputEvent(this.scratchMobileNumber);
      });
    },

    updateNationNumber(nationalNumber) {
      this.nationalNumber = nationalNumber;

      this.$nextTick(() => {
        this.emitInputEvent(this.scratchMobileNumber);
      });
    },

    handleCountryClear() {
      this.updateCountryCallingCode('');
    },

    // Your parent might want to know information about selected country
    handleCountrySelect(item) {
      this.$emit('select', item);
    },

    handleCountryCallingCodeChange(countryCallingCode) {
      this.updateCountryCallingCode(countryCallingCode);
    },

    handleNationalNumberInput(nationalNumber) {
      this.updateNationNumber(nationalNumber);
    },
  },
};

export default ARMobileInput;
